<template v-slot=button-content>
  <img v-bind:src="heartPicture" v-on:click.stop="saveHome" alt="Save Home">
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('user', [
      'getSavedHouses'
    ]),
    saved () {
      return this.getSavedHouses.includes(this.houseId)
    },
    heartPicture () {
      if (this.saved) return '/static/SavedHeart.svg'
      return '/static/SaveHeart.svg'
    }
  },
  methods: {
    ...mapActions('user', [
      'putUserData'
    ]),
    ...mapMutations('user', [
      'addSavedHouse',
      'removeSavedHouse'
    ]),
    async saveHome () {
      if (this.getIdProvider) {
        if (!this.saved) this.addSavedHouse(this.houseId)
        else if (this.saved) this.removeSavedHouse(this.houseId)
        await this.putUserData()
      } else {
        this.$emit('save-home-user-not-logged-in')
      }
    }
  },
  props: ['houseId']
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/general/buttons/SaveHomeButton.vue